var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A80364E0-8121-4CBC-93B4-0685800691BF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.4526,0.30540652 C11.61,-0.49199348 13.1598,0.36660652 13.1598,1.80300652 L13.1598,1.80300652 L13.1598,42.5964065 C13.1598,43.1310065 12.9312,43.6386065 12.5334,43.9806065 L12.5334,43.9806065 L2.8566,49.9800065 C1.7226,50.9574065 -5.52446977e-13,50.1222065 -5.52446977e-13,48.5976065 L-5.52446977e-13,48.5976065 L-5.52446977e-13,6.60360652 C-5.52446977e-13,6.00240652 0.2916,5.43900652 0.7758,5.10600652 L0.7758,5.10600652 Z M51.2919,0.30540652 C52.4511,-0.49199348 54.0009,0.36660652 54.0009,1.80300652 L54.0009,1.80300652 L54.0009,42.5964065 C54.0009,43.1310065 53.7705,43.6386065 53.3727,43.9806065 L53.3727,43.9806065 L43.6977,49.9800065 C42.5619,50.9574065 40.8411,50.1222065 40.8411,48.5976065 L40.8411,48.5976065 L40.8411,35.6340065 C40.9779,35.4558065 41.1381,35.2974065 41.2533,35.1012065 L41.2533,35.1012065 L50.0859,19.8012065 C52.9047,14.9160065 52.9047,9.08400652 50.0859,4.20060652 C49.5765,3.31860652 48.9717,2.52480652 48.3273,1.77600652 L48.3273,1.77600652 Z M18.00018,1.80228652 C18.00018,0.36588652 18.34758,-0.49091348 20.33838,0.30468652 L20.33838,0.30468652 L24.94998,1.85088652 C24.33978,2.57628652 23.76558,3.34128652 23.28138,4.19088652 C20.44998,9.14448652 20.45178,15.2698865 23.28318,20.1766865 L23.28318,20.1766865 L31.89978,35.1004865 C32.76198,36.5962865 34.30458,37.5376865 36.00018,37.7248865 L36.00018,37.7248865 L36.00018,48.5968865 C36.00018,50.1232865 35.35938,50.9566865 33.40638,49.9792865 L33.40638,49.9792865 L19.08018,43.9798865 C18.39618,43.6378865 18.00018,43.1302865 18.00018,42.5974865 L18.00018,42.5974865 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25988,17.1004865 C9.27908,17.1004865 6.85988,14.6830865 6.85988,11.7004865 C6.85988,8.71788652 9.27908,6.30048652 12.25988,6.30048652 C15.24248,6.30048652 17.65988,8.71788652 17.65988,11.7004865 C17.65988,14.6830865 15.24248,17.1004865 12.25988,17.1004865 M12.06368,0.000486519985 C2.87288,0.08148652 -2.59372,10.4188865 2.00168,18.3766865 L10.61648,33.3004865 C11.31128,34.5010865 13.04288,34.5010865 13.73408,33.3004865 L22.56848,18.0004865 C27.20528,9.96888652 21.36788,-0.08051348 12.06368,0.000486519985",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-564.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(336.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Map/40dp",
    transform: "translate(228.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(9.000000, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(33.400000, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.400000, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.185b933bc9a29dd670f78e7d43642ad4.svg";
export { ForwardRef as ReactComponent };